import React from 'react';

import { FormErrors } from '.';
import _ from '../../locale';
import { Field, FormInput, SubmitModal } from '../index';

type Props = {
    errors: FormErrors;
    localePrefix: string;
    onSubmit: () => void;
    onChange: (ev: { target: { name: string; value: any } }) => void;
    onClose: () => void;
    isVisible: boolean;
    isSubmittable: boolean;
    isSubmitting: boolean;
};

const CreateSmartOptionModalView: React.FC<Props> = (props: Props) => {
    const { errors, onClose, onSubmit, isVisible, isSubmittable, isSubmitting, localePrefix } =
        props;

    return (
        <SubmitModal
            title={_('create_smart_option_modal_title')}
            error={errors && errors.server ? errors.server : null}
            isVisible={isVisible}
            onClose={onClose}
            onSubmit={onSubmit}
            isSubmitting={isSubmitting}
            isSaveDisabled={!isSubmittable}
        >
            <Field
                autoFocus
                name="name"
                placeholder={_(`${localePrefix}name_placeholder`)}
                FormComponent={FormInput}
                {...props}
            />
        </SubmitModal>
    );
};

export default CreateSmartOptionModalView;
